export default {
  methods: {
    removeRow(url, name, value) {
      this.$bvModal.msgBoxConfirm(this.$t('common.confirmDelete'), {
        title: this.$t('common.delete'),
        size: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('common.confirm'),
        cancelTitle: this.$t('common.cancel'),
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      })

        .then(confirm => {
          if (confirm) {
            const obj = {}
            obj[name] = value
            this.$http.post(url, obj)
              .then(() => {
                this.update()
              })
          }
        })
    },
    avatarText(name) {
      if (!name) return ''
      const nameArray = name.split(' ')
      return nameArray.map(word => word.charAt(0).toUpperCase()).join(' ')
    },
  },
}
